import { RestError } from '@azure/core-http';
import { DeviceDetailDto, DeviceDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useQuery } from 'react-query';
import { useApi } from '../../core/api/api.context';

const DEVICE_MANAGEMENT_KEY = 'DEVICE_MANAGEMENT';
const HUB_KEY = 'HUB';
const DEVICE_KEY = 'DEVICE';

export function useQueryFindDevicesByHub(hubID: string | undefined, options?: { enabled?: boolean }) {
  const api = useApi();

  return useQuery<DeviceDto[], RestError>(
    [DEVICE_MANAGEMENT_KEY, HUB_KEY, hubID],
    async () => {
      if (!hubID) return [];
      return await api.deviceManagementController.findByHub(hubID);
    },
    { enabled: !!hubID && options?.enabled !== false, staleTime: 60_000 }
  );
}

export function useQueryGetDeviceDetails(deviceID: string | undefined, options?: { enabled?: boolean }) {
  const api = useApi();

  return useQuery<DeviceDetailDto | undefined, RestError>(
    [DEVICE_MANAGEMENT_KEY, DEVICE_KEY, deviceID],
    async () => {
      if (!deviceID) return undefined;
      return await api.deviceManagementController.getByAgentId(deviceID);
    },
    { enabled: !!deviceID && options?.enabled !== false, staleTime: 60_000 }
  );
}
